module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_3.3d181c02.png";